import React from 'react'
import styled from "styled-components"
import {getImageUrl} from "../../other/axios"

const Container = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    overflow: hidden;
    background-color: #000;
`

const Background = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    filter: blur(30px) brightness(0.4);
    transform: scale(1.1);
    transition: background-image 1s ease-in-out;
`

const Overlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(circle, rgba(0,0,0,0) 0%, rgba(0,0,0,0.8) 100%);
`

const BackgroundPlayer = ({image}) => {
    return (
        <Container>
            <Background style={{backgroundImage: `url(${getImageUrl(image)})`}} />
            <Overlay />
        </Container>
    )
}

export default BackgroundPlayer
